import * as THREE from 'three'
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js'
import gsap from 'gsap'
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader.js'

// Canvas
export const canvas = document.querySelector('canvas.webgl')

// Scene
export const scene = new THREE.Scene()
scene.background = new THREE.Color(0xf0f0f0)
scene.fog = new THREE.Fog(0xf0f0f0, 5, 10)

/**
 * Lights
 */
const keyLight = new THREE.DirectionalLight(0xf0f0f0, 2)
keyLight.position.set(5, 5, 5)
keyLight.castShadow = true
keyLight.shadow.mapSize.width = 1024
keyLight.shadow.mapSize.height = 1024
keyLight.shadow.camera.far = 15
scene.add(keyLight)

const fillLight = new THREE.DirectionalLight(0xf0f0f0, 0.8)
fillLight.position.set(-5, 2, 2)
scene.add(fillLight)

const backLight = new THREE.DirectionalLight(0xf0f0f0, 1.5)
backLight.position.set(0, 5, -5)
scene.add(backLight)

const ambientLight = new THREE.AmbientLight(0xf0f0f0, 0.3)
scene.add(ambientLight)

// Boden
const floorMaterial = new THREE.MeshBasicMaterial()
const floorGeometry = new THREE.PlaneGeometry(50, 50)
const floor = new THREE.Mesh(floorGeometry, floorMaterial)
floor.rotation.x = - Math.PI * 0.5
floor.position.y = -1
floor.receiveShadow = true
scene.add(floor)

// Object (3D-Drucker)
const glassMaterial = new THREE.MeshPhysicalMaterial({
    color: 0xffffff,
    metalness: 0,
    roughness: 0.02,
    transmission: 0.95,
    ior: 1.5,
    thickness: 0.2,
    specularIntensity: 1,
    specularColor: 0xffffff,
    opacity: 1,
    transparent: true,
    attenuationColor: 0x555555,
    attenuationDistance: 0.5
})

export let model = null
const loader = new GLTFLoader()

loader.load(
    'public/FLSUN_T1-Pro.glb',
    (gltf) => {
        model = gltf.scene
        model.position.set(0, -1, 0)
        model.traverse((node) => {
            if (node.name.includes('glas_scheibe') || node.name.includes('glas_tür')) {
                node.material = glassMaterial
            } else {
                node.castShadow = true
                node.receiveShadow = true
            }
        })

        // 1. Startzustand festlegen
        model.position.y = -2
        model.scale.set(0, 0, 0)
        model.rotation.y = Math.PI

        scene.add(model)

        // 2. Die GSAP Animation
        gsap.to(model.position, { y: -0.98, duration: 1.5, ease: 'power2.out' })
        gsap.to(model.scale, { x: 10, y: 10, z: 10, duration: 1.5, ease: 'back.out(1.5)' })
        gsap.to(model.rotation, { y: 0, duration: 2, ease: 'power2.inOut' })
    }
)

// Hotspots
export const hotspotsGroup = new THREE.Group()
hotspotsGroup.visible = false
scene.add(hotspotsGroup)

export const hotspotGeometry = new THREE.SphereGeometry(0.075, 16)
export const hotspotMaterial = new THREE.MeshBasicMaterial({ color: 0x0071e3 })

const hotspot1 = new THREE.Mesh(hotspotGeometry, hotspotMaterial)
hotspot1.position.set(0, 1.9, 0.26)
hotspot1.name = 'filament_ausladen'
hotspot1.cameraOffset = { x: 0.5, y: -0.5, z: 1 }
hotspotsGroup.add(hotspot1)

const hotspot2 = hotspot1.clone()
hotspot2.position.set(0, 0.7, 0.15)
hotspot2.name = 'filament_einladen'
hotspot2.cameraOffset = { x: 0, y: 0.225, z: 0.75 }
hotspotsGroup.add(hotspot2)

const hotspot3 = hotspot1.clone()
hotspot3.position.set(0, -0.775, 0)
hotspot3.name = 'druckplatte'
hotspot3.cameraOffset = { x: 0, y: 0.225, z: 0.75 }
hotspotsGroup.add(hotspot3)

const hotspot4 = hotspot1.clone()
hotspot4.position.set(0, -0.875, 0.7)
hotspot4.name = 'display'
hotspot4.cameraOffset = { x: 0, y: 0.125, z: 0.3 }
hotspotsGroup.add(hotspot4)

// Sizes
export const sizes = {
    width: window.innerWidth,
    height: window.innerHeight
}

// Camera
export const camera = new THREE.PerspectiveCamera(75, sizes.width / sizes.height, 0.1, 100)
camera.position.set(0, 3, 6)
camera.lookAt(0, 2, 0)
scene.add(camera)

// Controls
export const controls = new OrbitControls(camera, canvas)
controls.enableDamping = true
controls.enabled = false

// Renderer
export const renderer = new THREE.WebGLRenderer({ canvas: canvas })
renderer.setSize(sizes.width, sizes.height)
renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))
renderer.shadowMap.enabled = true
renderer.shadowMap.type = THREE.PCFSoftShadowMap